import React from "react";
import Solicitudes from "../../components/2.2 postulantes/postulantes";

const HomePage = () => {
  return (
    <>
      <Solicitudes />
    </>
  );
};

export default HomePage;
